/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { METHODS_TO_ENROLL } from '../modals/manager';

// Max secure contact verified_at age of 5 minutes allowed for taking action on secure contact management options.
export const MAX_SECURE_CONTACT_VERIFIED_AT_AGE_IN_MILLIS = 5 * 60 * 1000;

/**
 * Input Props
 * @listSecureContactResponse - https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListSecureContactResponse
 */
let SecureContactMenuBaseComponent = (_dec = service('ember-multipass-flag'), _dec2 = service('ember-multipassfe-client'), _class = class SecureContactMenuBaseComponent extends Component {
  get phoneSecureContactDetail() {
    return this.multipassfeClient.secureContactDetails?.filter(x => x.phone) || [];
  }
  get emailSecureContactDetails() {
    return this.multipassfeClient.secureContactDetails?.filter(x => x.email) || [];
  }
  get showEnrollTwoFactorAsSecureContactBanner() {
    return this.phoneSecureContactDetail.length === 0 && this.multipassfeClient.secureContactEligibleSmsTwoFactorDetails.length > 0;
  }
  get enrollTwoFactorAsSecureContactNumberBannerTLabel() {
    return this.multipassfeClient.secureContactEligibleSmsTwoFactorDetails.length === 1 ? 'secure_contact.menu.enroll_two_factor_number_single' : 'secure_contact.menu.enroll_two_factor_number_multiple';
  }
  constructor() {
    super(...arguments);
    // Cache passed in results for downstream components, else fetch current value
    _initializerDefineProperty(this, "flags", _descriptor, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor2, this);
    _defineProperty(this, "methodsToEnroll", METHODS_TO_ENROLL);
    _initializerDefineProperty(this, "detailToBeVerified", _descriptor3, this);
    _initializerDefineProperty(this, "enrollFromTwoFactorPhoneModalOpen", _descriptor4, this);
    _initializerDefineProperty(this, "enrollModalOpen", _descriptor5, this);
    _initializerDefineProperty(this, "manageModalOpen", _descriptor6, this);
    _initializerDefineProperty(this, "methodToEnroll", _descriptor7, this);
    _initializerDefineProperty(this, "suggestedTwoFactorDetail", _descriptor8, this);
    this.cacheSecureContactDetails();

    // Set suggested 2FA detail to enroll as secure contact, when there is only one SMS detail
    if (this.showEnrollTwoFactorAsSecureContactBanner && this.multipassfeClient.secureContactEligibleSmsTwoFactorDetails.length === 1) {
      this.suggestedTwoFactorDetail = this.multipassfeClient.secureContactEligibleSmsTwoFactorDetails[0];
    }
  }
  cacheSecureContactDetails() {
    if (this.args.listSecureContactResponse !== undefined) {
      this.multipassfeClient.secureContactDetails = this.args.listSecureContactResponse.secure_contact_details;
    } else {
      this.multipassfeClient.listSecureContact();
    }
  }
  handleEnrollFromTwoFactorPhoneModalOpen() {
    const reverifyCandidate = this.emailSecureContactDetails.length > 0 ? this.emailSecureContactDetails[0] : undefined;
    if (reverifyCandidate && needsToReverifySecureContact(reverifyCandidate)) {
      this.detailToBeVerified = reverifyCandidate;
    }
    this.enrollFromTwoFactorPhoneModalOpen = true;
  }
  handleEnrollPhone() {
    this.methodToEnroll = METHODS_TO_ENROLL.PHONE;
    this.handleEnrollModalOpen();
  }
  handleEnrollEmail() {
    this.methodToEnroll = METHODS_TO_ENROLL.EMAIL;
    this.handleEnrollModalOpen();
  }
  handleEnrollModalOpen() {
    this.enrollModalOpen = true;
  }
  handleEnrollModalClose() {
    this.enrollModalOpen = false;
    this.detailToBeVerified = undefined;
    this.detailToBeUpdated = undefined;
  }
  handleEnrollFromTwoFactorPhoneModalClose() {
    this.enrollFromTwoFactorPhoneModalOpen = false;
    this.detailToBeVerified = undefined;
  }
  handleManageModalOpen() {
    this.manageModalOpen = true;
  }
  handleManageModalClose() {
    this.manageModalOpen = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "flags", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "detailToBeVerified", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "enrollFromTwoFactorPhoneModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "enrollModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "manageModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "methodToEnroll", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "suggestedTwoFactorDetail", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleEnrollFromTwoFactorPhoneModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollFromTwoFactorPhoneModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollEmail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollFromTwoFactorPhoneModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollFromTwoFactorPhoneModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleManageModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleManageModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleManageModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleManageModalClose"), _class.prototype), _class);
export { SecureContactMenuBaseComponent as default };
/**
 *
 * @param detail secure contact detail to have verified_at timestamp evaluated
 * @returns {boolean} whether secure contact re-verification must take place to proceed
 */
export function needsToReverifySecureContact(detail) {
  if (detail === undefined) {
    return false;
  }
  return detail.verified_at + MAX_SECURE_CONTACT_VERIFIED_AT_AGE_IN_MILLIS < Date.now();
}